import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import Modal from "../modal/Modal";
import OnboardingFeatureCarousel from "./OnboardingFeatureCarousel";
import { scStringType } from "../../types";
import { AuthenticationState } from "react-aad-msal";
import { getLoyaltyStorage } from "../../util";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";

var Onboarding = function Onboarding(props) {
  var authenticationState = props.authenticationState;

  var _ref = (props === null || props === void 0 ? void 0 : props.model) || {},
      BackButton = _ref.BackButton,
      NextButton = _ref.NextButton,
      DoneButton = _ref.DoneButton,
      Carousel = _ref.Carousel;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var loyaltyStorage = getLoyaltyStorage();
  useEffect(function () {
    var _loyaltyStorage$accou;

    if (authenticationState !== AuthenticationState.Authenticated || (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused) {
      return;
    }

    var showOnboardingModal = getCookieValue("showOnboardingModal");

    if (showOnboardingModal === "true") {
      setIsOpen(true);
      deleteCookie("showOnboardingModal");
    }
  }, []);

  var handleHide = function handleHide() {
    setIsOpen(false);
  };

  var handleDone = function handleDone() {
    setIsOpen(false);
  };

  var getCookieValue = function getCookieValue(name) {
    var _document$cookie$matc;

    return ((_document$cookie$matc = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop()) || "";
  };

  var deleteCookie = function deleteCookie(cookieName) {
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: "loyalty-modal onboarding-modal",
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true
  }, /*#__PURE__*/React.createElement(OnboardingFeatureCarousel, {
    BackButton: BackButton,
    NextButton: NextButton,
    DoneButton: DoneButton,
    Carousel: Carousel,
    handleDone: handleDone
  }));
};

export default Onboarding;